import { useState } from 'react';
import { Shield } from 'lucide-react';
import { PRIVACY_POLICY } from '../../lib/privacyPolicy';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

function InvitationPrivacyNotice({ className = '' }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={`mt-8 border-t border-[var(--ba-surface-border)] pt-4 text-center ${className}`}>
        <p className="text-xs ba-muted">
          Inviando i dati dichiari di aver preso visione dell&apos;{' '}
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="font-semibold text-brand-orange underline decoration-brand-orange/40 underline-offset-2 transition-colors hover:text-brand-green hover:decoration-brand-green/50"
          >
            {PRIVACY_POLICY.shortLabel}
          </button>
          .
        </p>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex max-h-[min(85vh,40rem)] max-w-lg flex-col gap-0 overflow-hidden p-0 sm:max-w-xl">
          <DialogHeader className="shrink-0 border-b border-[var(--ba-surface-border)] px-5 py-4 text-left sm:px-6">
            <DialogTitle className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-brand-orange" aria-hidden />
              {PRIVACY_POLICY.title}
            </DialogTitle>
            <DialogDescription>{PRIVACY_POLICY.lastUpdatedLabel}</DialogDescription>
          </DialogHeader>

          <div className="min-h-0 flex-1 space-y-5 overflow-y-auto px-5 py-4 text-left text-sm leading-relaxed sm:px-6">
            {PRIVACY_POLICY.sections.map((section) => (
              <section key={section.title}>
                <h3 className="mb-1.5 font-semibold text-[var(--ba-body-text)]">{section.title}</h3>
                <div className="space-y-2 ba-muted">
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph.slice(0, 48)}>{paragraph}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <DialogFooter className="shrink-0 border-t border-[var(--ba-surface-border)] px-5 py-3 sm:px-6">
            <Button type="button" onClick={() => setOpen(false)}>
              Chiudi
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default InvitationPrivacyNotice;
